import PathwaysContainer from './pathways_container';

const Pathways = PathwaysContainer;
export default Pathways;
